export const GET_COMPARE_INFOS_EKYCS = "GET_COMPARE_INFOS_EKYCS"
export const GET_COMPARE_INFOS_EKYCS_ERR = "GET_COMPARE_INFOS_EKYCS_ERR"